import { isEmpty } from "lodash";
import { t } from "@/i18n-js/instance";
import { SliderField } from "@circle-react-shared/BuilderUI/Editor/fields/SliderField";
import { useCustomColors } from "@circle-react-shared/BuilderUI/ThemeConfiguration/hooks/useCustomColors";
import { Form } from "@circle-react-uikit/Form";
import { EditorCollapsable } from "../../../../Editor/EditorCollapsable";
import type { ButtonVariant } from "./ButtonStateSelector";
import { generateFormItemName } from "./Styles";

interface BordersProps {
  selectedButtonVariant: ButtonVariant;
}

export const Borders = ({ selectedButtonVariant }: BordersProps) => {
  const {
    flattenedCssVariables,
    themeColors,
    customColors,
    handleAddCustomColor,
  } = useCustomColors();
  return (
    <EditorCollapsable
      title={t("builder_ui.prop_type.styles.border")}
      defaultOpen
    >
      <div className="space-y-4 px-6 py-5">
        <Form.Item
          name={generateFormItemName(selectedButtonVariant, "borderColor")}
          label={t("builder_ui.prop_type.styles.border_color")}
          hideDescription
          hideBorder
          labelClassName="!font-normal !text-xs"
          className="!flex !w-full !items-center !justify-between !p-0"
        >
          <Form.ColorPickerV2
            name={generateFormItemName(selectedButtonVariant, "borderColor")}
            cssVariables={flattenedCssVariables}
            shouldResolveCssVariable={Boolean(flattenedCssVariables)}
            shouldRenderThemeColors={!isEmpty(themeColors)}
            shouldShowAlpha={false}
            themeColors={themeColors}
            customColors={customColors}
            onAddCustomColor={
              !isEmpty(themeColors) ? handleAddCustomColor : undefined
            }
          />
        </Form.Item>

        <SliderField
          name={generateFormItemName(selectedButtonVariant, "borderWidth")}
          label={t("builder_ui.prop_type.styles.border_width")}
          units={["px", "rem"]}
          step={1}
          min={0}
          max={100}
        />
      </div>
    </EditorCollapsable>
  );
};
